export var MessageTypeTokens;
(function (MessageTypeTokens) {
    MessageTypeTokens["ERROR"] = "ERROR";
    MessageTypeTokens["SUCCESS"] = "SUCCESS";
    MessageTypeTokens["INFO"] = "INFO";
    MessageTypeTokens["WARNING"] = "WARNING";
})(MessageTypeTokens || (MessageTypeTokens = {}));
export var MessageAlignType;
(function (MessageAlignType) {
    MessageAlignType["FLEX_START"] = "flex-start";
    MessageAlignType["FLEX_END"] = "flex-end";
    MessageAlignType["CENTER"] = "center";
})(MessageAlignType || (MessageAlignType = {}));
